import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import OrderFile from "../../../models/OrderFile";
import { API_URL } from "../../../utils/Constants";
import { useAppDispatch } from "../../../utils/Hooks";
import { deleteOrderFile } from "../../../store/reducers/OrdersSlice";

interface ElogUploadProps {
    label: string;
    name: string;
    mandatory?: boolean;
    classes?: string;
    files?: OrderFile[];
    allowDeleteExisting?: boolean;
}

const ElogUpload: React.FC<ElogUploadProps> = ({ label, name, mandatory = false, classes, files, allowDeleteExisting = true }) => {
    const dispatch = useAppDispatch();
    const { setFieldValue } = useFormikContext();
    const [fileFields, setFileFields] = useState<File[]>([new File([], 'dummy')]);
    const [displayFiles, setDisplayFiles] = useState<OrderFile[]>([]);

    useEffect(() => {
        if (files) {
            setDisplayFiles(files);
        }
    }, [files]);

    const handleFileSelection = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const fileList = event.target.files;
        if (fileList && fileList.length > 0) {
            setFieldValue(`${name}.${index}`, fileList[0]);
        } else {
            setFieldValue(`${name}.${index}`, null);
        }
    };

    const handleAddFileField = (): void => {
        setFileFields(prevFileFields => [...prevFileFields, new File([], 'dummy')]);
    };

    const handleRemoveFileField = (index: number): void => {
        setFileFields(prevFileFields => {
            const updatedFields = [...prevFileFields];
            updatedFields.splice(index, 1);
            return updatedFields;
        });
    };

    const deleteFile = (fileId: number): void => {
        dispatch(deleteOrderFile({ id: fileId }));
        setDisplayFiles(displayFiles.filter(file => file.id !== fileId));
    };

    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td>
                <div>
                    {displayFiles?.map(file => (
                        <div key={file.id} style={{ marginBottom: '5px' }}>
                            <a key={file.id} href={API_URL + 'download-file/' + file.id + '?token=' + localStorage.getItem('token') } target="_blank">{file.name}</a>
                            {allowDeleteExisting &&
                            <a href="Javascript:;" style={{ color: 'red', marginLeft: '10px' }} onClick={() => deleteFile(file.id)}> [x] </a>}
                            <br />
                        </div>
                    ))}
                </div>
                <div>
                    {fileFields.map((file, index) => (
                        <div key={index} style={{ marginBottom: '10px' }}>
                            <label style={{ fontWeight: 'bold' }}>
                                <input
                                    type="file"
                                    name={`${name}.${index}`}
                                    onChange={(event) => handleFileSelection(event, index)}
                                />
                            </label>
                            {index > 0 && <button type="button" style={{ marginLeft: '10px' }} onClick={() => handleRemoveFileField(index)}>Eemalda</button>}
                        </div>
                    ))}
                    <button style={{ fontWeight: 'bold' }} type="button" onClick={handleAddFileField}>Lisa veel</button>
                </div>
            </td>
        </tr>
    );
};

export default ElogUpload;
